"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UnlockIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UnlockIcon, _React$PureComponent);

  function UnlockIcon() {
    _classCallCheck(this, UnlockIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnlockIcon).apply(this, arguments));
  }

  _createClass(UnlockIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'open-lock-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M10,5.99995739 L8,5.99995739 L7,5.99995739 L4,5.99995739 L4,4.10694395 C4,3.11093687 4.681,2.18693031 5.664,2.02692917 C6.692,1.85992799 7.605,2.47793238 7.9,3.37493875 C8.019,3.7339413 8.318,3.99994319 8.695,3.99994319 L8.838,3.99994319 C9.511,3.99994319 10.003,3.33593847 9.784,2.69993395 C9.204,1.01292197 7.528,-0.165086394 5.607,0.0189149129 C3.527,0.216916319 2,2.08292957 2,4.17194441 L2,5.99995739 C1.447,5.99995739 1,6.44796057 1,6.99996449 L1,11 C1,11.5519968 1.447,12 2,12 L10,12 C10.553,12 11,11.5519968 11,11 L11,6.99996449 C11,6.44796057 10.553,5.99995739 10,5.99995739"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return UnlockIcon;
}(_react.default.PureComponent);

exports.default = UnlockIcon;
UnlockIcon.defaultProps = {
  color: 'inherit'
};
UnlockIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};